import * as Sentry from '@sentry/react'

import { env } from '@percent/admin-dashboard/env'

// eslint-disable-next-line no-console
const consoleErr = (error: Error) => console.log(error)

export const logger = (error: Error) => {
  if (env.NX_PUBLIC_USE_SENTRY_LOGGER === true) {
    return Sentry.captureException(error)
  }

  return consoleErr(error)
}
